import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import SEO from "./seoData";

const SITE = "https://www.netplus.co.in";

// Render ONCE inside <Router> in App.js. Replaces Canonical.js.
const Seo = () => {
  const { pathname } = useLocation();
  const clean = pathname.replace(/\/+$/, ""); // keep case (booking IDs are case-sensitive)
  const url = `${SITE}${clean}/`; // exactly one trailing slash
  const page = SEO[clean.toLowerCase()]; // lookup only; URL itself is not lowercased

  return (
    <Helmet>
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      {page && <title>{page.title}</title>}
      {page && <meta name="description" content={page.description} />}
      {page && <meta property="og:title" content={page.title} />}
      {page && <meta property="og:description" content={page.description} />}
    </Helmet>
  );
};

export default Seo;
